import { useExperiment } from '../useExperiment/useExperiment'
import { Attributes } from '../../shared/DefaultSubjectAttributes'

export const useFlag = <R>(
  experimentKey: string,
  args: { fallback: R; subjectAttributes?: Attributes },
): R => {
  const nonLoggingArgs = {
    ...args,
    subjectAttributes: { ...args.subjectAttributes, shouldLog: false },
  }
  return useExperiment<R>(experimentKey, nonLoggingArgs)
}
